<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <b-row>
      <b-col sm="6">
        <admin-breadcrumb name="Users"/>
      </b-col>
      <b-col sm="6" class="text-right align-self-end">
        <no-permission-wrapper :show="!canCreateUsers">
          <b-btn variant="success" @click.prevent="openNewUserModal" class="mb-4" :disabled="!canCreateUsers">Add New User</b-btn>
        </no-permission-wrapper>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <admin-panel title="Users" sub-title="Manage all users registered in GreenLists" with-footer>
          <admin-users-table :users="users" :sort-by="sortBy" :sort-desc="sortDesc" @sort-changed="onSortChanged"/>
          <template v-slot:header-right>
            <admin-companies-autocomplete v-model="filters.company"/>
            <b-form-select
              class="w-auto ml-2"
              v-model="filters.status"
              :options="statusOptions"
              @change="() => loadUsers()"
            />
            <b-form-select
              class="w-auto ml-2"
              v-model="filters.role"
              :options="roleOptions"
              @change="() => loadUsers()"
            />
          </template>
          <template v-slot:footer>
            <b-pagination
                v-model="page"
                :total-rows="total_in_pages"
                :per-page="per_page"
                @change="loadUsers"
                align="center"
                class="admin-pagination mb-0"
            />
          </template>
        </admin-panel>
      </b-col>
    </b-row>
    <admin-new-user-modal ref="newUserModal" @created="newUserCreated" :skip-admin-role="!canCreateAdmins"/>
  </b-container>
</template>

<script>
import AdminPanel from "../components/AdminPanel";
import {API_ROUTES} from "../api";
import AdminPreloader from "../components/AdminPreloader";
import AdminUsersTable from "../components/AdminUsersTable";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import AdminNewUserModal from "../components/AdminNewUserModal";
import AdminCompaniesAutocomplete from "../components/AdminCompaniesAutocomplete";
import NoPermissionWrapper from "../components/NoPermissionWrapper.vue";

export default {
  name: "AdminUsers",
  components: {
    NoPermissionWrapper,
    AdminCompaniesAutocomplete,
    AdminNewUserModal, AdminBreadcrumb, AdminUsersTable, AdminPreloader, AdminPanel},
  data() {
    return {
      users: [],
      loading: true,
      page: 1,
      per_page: 10,
      total_in_pages: 0,
      filters: {
        company: null,
        role: "",
        status: ""
      },
      sortBy: 'date_added',
      sortDesc: false,
      statusOptions: [
        {
          text: 'All Statuses',
          value: ''
        },
        {
          text: 'Active',
          value: 1
        },
        {
          text: 'Inactive',
          value: 0
        }
      ]
    }
  },
  created() {
    const sort = localStorage.getItem('user_sorting');
    if (sort === 'last_created') this.sortDesc = true;
    if (sort === 'first_created') this.sortDesc = false;

    this.loadUsers();
  },
  computed: {
    canCreateUsers() {
      return this.$store.getters['auth/hasAdminPermissions']('user_create');
    },
    canCreateAdmins() {
      return this.$store.getters['auth/hasAdminPermissions']('admin_create');
    },
    search() {
      return this.$store.state.current.search;
    },
    roleOptions() {
      let options = this.$store.state.data.user_roles.map(role => ({
        text: role.name,
        value: role.id
      }));
      options.unshift({
        text: 'All Roles',
        value: ''
      });

      return options;
    }
  },
  watch: {
    search() {
      this.loadUsers();
    },
    "filters.company": function() {
      this.loadUsers();
    }
  },
  methods: {
    onSortChanged({ sortBy, sortDesc }) {
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;

      const sorting = sortDesc ? 'last_created' : 'first_created';
      localStorage.setItem('user_sorting', sorting);

      this.loadUsers(1);
    },
    loadUsers(page = 1) {
      this.loading = true;
      let params = {
        page: page,
        per_page: this.per_page
      };
      if (this.search) {
        params['search'] = this.search;
      }
      if (this.filters.company) {
        params['company'] = this.filters.company.id;
      }
      if (this.filters.role) {
        params['role'] = this.filters.role;
      }
      if (this.filters.status !== '') {
        params['is_active'] = this.filters.status;
      }
      this.$api.get(API_ROUTES.ADMIN_USERS, {
        params: params
      }).then(({data}) => {
        this.users = data.users;
        this.total_in_pages = data.meta.total;
      }).catch(({response}) => {

      }).finally(() => {
        if (page !== this.page) {
          this.page = page;
        }
        this.loading = false;
      });
    },
    openNewUserModal() {
      if (!this.canCreateUsers) {
        return this.$bvToast.toast('Sorry! You don\'t have permission to do this action', {
          title: 'Denied!',
          variant: 'danger'
        });
      }
      this.$refs.newUserModal.open();
    },
    newUserCreated(user) {
      this.users.push(user);
      this.$refs.newUserModal.close();
    }
  }
}
</script>
